import { authAxios } from "@/axios/axios";
import { THREAD_STATE_ACTIONS } from "../../constants";

const RESTAURANT_MESSAGING_API_BASE_PATH = '/messaging/threads/';

export async function getChatThreads({ limit = 20, offset = 0, search = "", withAtLeastAMessage = true } = {}) {
    const params = { limit, offset };
    if (search) 
        params.search = search;
    if (withAtLeastAMessage) 
        params.with_at_least_a_message = 1;
    const res = await authAxios.get(RESTAURANT_MESSAGING_API_BASE_PATH, { params });
    return res.data;
}

export async function getChatThreadMessages(threadId, params = {}) {
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}${threadId}/messages/`;
    const res = await authAxios.get(url, { params });
    return res.data;
}

export async function postChatThreadMessage(threadId, content) {
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}${threadId}/messages/`;
    const res = await authAxios.post(url, { content });
    return res.data;
}

const THREAD_STATE_ACTIONS_LIST = Object.values(THREAD_STATE_ACTIONS);

function assertThreadStateAction(action) {
    if (!THREAD_STATE_ACTIONS_LIST.includes(action)) {
        throw new Error(
            `Action "${action}" non autorisée. Autorisées: ${THREAD_STATE_ACTIONS_LIST.join(", ")}`
        );
    }
}

export async function postThreadStateAction(threadId, action) {
    assertThreadStateAction(action);
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}${threadId}/state/`;
    const res = await authAxios.post(url, null, { params: { action } });
    return res.data;
}

export async function postBulkThreadStateAction(threadsIds = [], action) {
    assertThreadStateAction(action);
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}state/`;
    const payload = { threads_ids: threadsIds };
    const res = await authAxios.post(url, payload, { params: { action } });
    return res.data;
}

export async function getChatThreadUnreadMessagesCount(threadId) {
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}${threadId}/unread-messages-count/`;
    const res = await authAxios.get(url);
    return res.data;
}

export async function getUnreadThreadsCount() {
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}unread-threads-count/`;
    const res = await authAxios.get(url);
    return res.data;
}

export async function getChatThreadsUnreadMessagesCount(threadIds) {
    const url = `${RESTAURANT_MESSAGING_API_BASE_PATH}unread-messages-counts/`;

    const res = await authAxios.post(url, {
        threads_ids: threadIds,
    });

    return res.data;
}


// WEBPACK FOOTER //
// ./src/features/messaging/queries/threads/requests.js